import { Box, Typography } from '@mui/material';
import { FC, useRef } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { useDispatch } from 'react-redux';
import { loginRequest } from 'redux/reducers/auth/reducer';
import { RECAPTCHA_SITE_KEY } from 'services/constants/env';

export const ReCaptchaPage: FC = () => {
	const dispatch = useDispatch();
	const recaptchaRef = useRef<ReCAPTCHA | null>(null);
	const handleRecaptchaChange = (token: string | null) => {
		if (token) {
			console.log('reCAPTCHA token:', token);
			dispatch(loginRequest({ token }));
		}
	};

	return (
		<Box
			component="div"
			sx={{
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
				justifyContent: 'center',
				height: '100vh',
				width: '100%',
				backgroundColor: 'primary.main',
			}}
		>
			<Box
				sx={{
					display: 'flex',
					flexDirection: 'row',
					alignItems: 'center',
					gap: '6px',
					mb: '1rem',
					mt: '-8rem',
				}}
			>
				<img
					className="logo-footer"
					src="/img/EAS-logo.svg"
					alt=""
					style={{
						border: '2px solid white',
						borderRadius: '50%',
						height: '60px',
						width: '60px',
					}}
				/>
				<Typography
					variant="body1"
					color="white"
					sx={{
						fontSize: { md: 28, xs: 28 },
						fontWeight: 600,
					}}
				>
					GPSR Database
				</Typography>
			</Box>
			<ReCAPTCHA
				sitekey={RECAPTCHA_SITE_KEY}
				onChange={handleRecaptchaChange}
				ref={recaptchaRef}
				size="normal"
			/>
		</Box>
	);
};
